import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';

import {
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';
import { mailOcularImages, createMetadataEmail } from '../../helpers/ocularMailing';

import { FormikValues } from '../../components/SearchAllContent/types';

import { SearchOcularDB } from '../../components';

import './style.scss';

const HTTP_STATUS_OK = 200;

const SearchOcularDBFull = () => {
  const { t } = useTranslation();
  const [exportLoading, setExportLoading] = useState(false);
  const [exportType, setExportType] = useState<'export_images' | 'request_metadata'>('export_images');

  const startExport = async (values: FormikValues) => {
    if (Object.values(values).filter((value) => value === true).length === 0) {
      toast.error(t('components.search_oculardb.export.select_one'));
      return;
    }

    setExportLoading(true);
    const result = await mailOcularImages(values);
    if (result.status === HTTP_STATUS_OK) {
      toast.success(t('components.search_oculardb.export.success'));
    } else {
      toast.error(result.data.error || t('components.search_oculardb.export.error'));
    }
    setExportLoading(false);
  };

  const requestMetadata = (values: FormikValues) => {
    if (Object.values(values).filter((value) => value === true).length === 0) {
      toast.error(t('components.search_oculardb.export.select_one'));
    } else {
      createMetadataEmail(values);
    }
  };

  return (
    <>
      <div className="SearchOcularDB__header">
        <Container>
          <h1 className="SearchOcularDB__header__title">{t('components.search_oculardb.title')}</h1>
          <h4 className="SearchOcularDB__header__subtitle">{t('components.search_oculardb.subtitle')}</h4>
        </Container>
      </div>
      <Container>
        <SearchOcularDB>
          <div className="row">
            <div className="col-12 mb-8 mb-lg-12">
              <SearchOcularDB.SearchBar />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-4 mb-8 mb-lg-0">
              <SearchOcularDB.Facets />
            </div>

            <div className="col-12 col-lg-8">
              <div className="d-flex justify-content-between align-items-center mb-8 mb-lg-6">
                <SearchOcularDB.Stats />
              </div>

              <FormikWrapper
                initialValues={{}}
                onSubmit={(values: FormikValues) => {
                  if (exportType === 'export_images') {
                    startExport(values)
                      .then(() => {})
                      .catch(() => {})
                      .finally(() => {});
                  }

                  if (exportType === 'request_metadata') {
                    requestMetadata(values);
                  }
                }}
              >
                <SearchOcularDB.Results />
                <SearchOcularDB.Pagination className="mt-8" />
                <SearchOcularDB.Export
                  isLoading={exportLoading}
                  setExportType={setExportType}
                />
                <Toaster />
              </FormikWrapper>

              <SearchOcularDB.CTA />

            </div>
          </div>
        </SearchOcularDB>
      </Container>
    </>
  );
};

export default SearchOcularDBFull;
